// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2yL3u","balanceDisclaimer":"posDashboard_balanceDisclaimer__1eZHy"};